import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth-service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import {
  AdminSupplierRequestBody,
  AdminSuppliersResponseBody,
  OneSupplierResponseData,
} from '../../pages/admin-dashboard/admin-supplier/admin-supplier.model';
import { ErrorVTO } from '../auth-service.model';

@Injectable({
  providedIn: 'root',
})
export class SuppliersService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.productsApiUrl;

  getAllSuppliers(paramsIn?: {
    supplierTitle?: string;
    pageSize?: number;
    pageOffset?: number;
    pageNum?: number;
    orderBy?: string;
    orderDir?: 'ASC' | 'DESC';
    createdOnFrom?: string;
    createdOnTo?: string;
    isActive?: boolean;
  }) {
    let params = new HttpParams();
    if (paramsIn) {
      if (paramsIn.supplierTitle) {
        params = params.set('title', paramsIn.supplierTitle);
      }
      if (paramsIn.pageSize) {
        params = params.set('pageSize', paramsIn.pageSize.toString());
      }
      if (paramsIn.pageOffset) {
        params = params.set('pageOffset', paramsIn.pageOffset.toString());
      }
      if (paramsIn.pageNum) {
        params = params.set('pageNum', paramsIn.pageNum.toString());
      }
      if (paramsIn.orderBy) {
        params = params.set('orderBy', paramsIn.orderBy);
      }
      if (paramsIn.orderDir) {
        params = params.set('orderDir', paramsIn.orderDir);
      }
      if (paramsIn.createdOnFrom) {
        params = params.set('createdOnFrom', paramsIn.createdOnFrom);
      }
      if (paramsIn.createdOnTo) {
        params = params.set('createdOnTo', paramsIn.createdOnTo);
      }
      if (paramsIn.isActive) {
        params = params.set('isActive', paramsIn.isActive);
      }
    }
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<AdminSuppliersResponseBody>(`${this.API}/suppliers`, { params, headers }).pipe(
      tap(() => console.log('suppliers retrieved successfully')),
      catchError(this.handleError),
    );
  }

  createSupplier(dto: AdminSupplierRequestBody) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.post(`${this.API}/suppliers`, dto, { headers }).pipe(
      tap(() => console.log('Supplier created successfully')),
      catchError(this.handleError),
    );
  }

  getOneSupplier(supplierId: number) {
    console.log('fetching supplier with id:', supplierId);
    let headers = new HttpHeaders();
    // headers = headers.set('X-No-Cache', 'true');
    const token = this.authService.getAccessToken();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<OneSupplierResponseData>(`${this.API}/suppliers/${supplierId}`, { headers }).pipe(
      tap(() => console.log('supplier retrieved successfully')),
      catchError(this.handleError),
    );
  }

  updateSupplier(supplierId: number, dto: AdminSupplierRequestBody) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/suppliers/${supplierId}`, dto, { headers }).pipe(
      tap(() => console.log('supplier updated successfully')),
      catchError(this.handleError),
    );
  }

  activateSupplier(supplierId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/suppliers/${supplierId}/activate`, {}, { headers }).pipe(
      tap(() => console.log('supplier activated successfully')),
      catchError(this.handleError),
    );
  }

  deactivateSupplier(supplierId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/suppliers/${supplierId}/deactivate`, {}, { headers }).pipe(
      tap(() => console.log('supplier deactivated successfully')),
      catchError(this.handleError),
    );
  }

  deleteSupplier(supplierId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    console.log('Deleting supplier with ID:', supplierId);
    return this.http.delete<void>(`${this.API}/suppliers/${supplierId}`, { headers }).pipe(
      tap(() => console.log('supplier deleted successfully')),
      catchError(this.handleError),
    );
  }

  // getSubcategories(paramsIn: { subcategoryId: number; orderBy?: string; orderDir?: 'ASC' | 'DESC' }) {
  //   let params = new HttpParams()
  //     .set('subcategoryId', paramsIn.subcategoryId.toString())
  //     .set('orderBy', paramsIn.orderBy || 'CREATION_DATE');

  //   if (paramsIn.orderDir) {
  //     params = params.set('orderDir', paramsIn.orderDir);
  //   }

  //   const token = this.authService.getAccessToken();
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }

  //   return this.http.get<SubcategoryResultSet>(`${this.API}/subcategories`, { params, headers }).pipe(
  //     tap(() => console.log(`Subcategories for category ${paramsIn.subcategoryId} retrieved`)),
  //     catchError(this.handleError),
  //   );
  // }

  private handleError(error: HttpErrorResponse) {
    const apiError: ErrorVTO = error.error;
    console.error('An API error occurred:', apiError);
    return throwError(() => apiError);
  }
}
